import { AxiosError, AxiosResponse } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import type RepositoryResponse from '@/types/repositoryResponse';
import type { StaffUserSession } from '@/types/staffSession';
import ajax from '@/utils/ajax';
import logAjaxError from '@/utils/logAjaxError';

export const authRepository = {
  async getToken({
    host,
    token
  }: {
    host: string;
    token: string;
  }): Promise<RepositoryResponse<StaffUserSession>> {
    try {
      const path = `/api/dugout/tokens/google/`;

      const response = await ajax.post<{ token: string }, AxiosResponse<StaffUserSession>>({
        url: `${host}${path}`,
        data: { token }
      });

      return {
        data: response.data,
        isError: false
      };
    } catch (error) {
      logAjaxError(error);

      return {
        errorMessage: `Failed to get profile data: ${(error as AxiosError).message}`,
        error: error as AxiosError,
        isError: true
      };
    }
  },
  async getHealthieApiKey({
    host
  }: {
    host: string;
  }): Promise<RepositoryResponse<{ healthie_api_key: string }>> {
    try {
      const path = `/api/dugout/tokens/healthie/`;

      const response = await ajax.get({
        url: `${host}${path}`
      });

      return response.data;
    } catch (error) {
      logAjaxError(error);
      return {
        errorMessage: `Failed to get Healthie API key: ${(error as AxiosError).message}`,
        error: error as AxiosError,
        isError: true
      };
    }
  }
};

const AuthRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getToken(token: string): Promise<RepositoryResponse<StaffUserSession>> {
      return authRepository.getToken({ host, token });
    },
    async getHealthieApiKey(): Promise<RepositoryResponse<{ healthie_api_key: string }>> {
      return authRepository.getHealthieApiKey({ host });
    }
  };
};

export default AuthRepository;
